<template>
  <div class="w-100">
    <proa-heading>{{ $t('pages.management.heading') }}</proa-heading>
    <b-container fluid class="p-0">
        <b-row no-gutters>
          <b-col cols="12" class="mt-4 pt-3">
            <proa-heading sub class="mb-3 pb-1">{{ $t('pages.management.basicInformation.heading') }}</proa-heading>
            <proa-card>
              <proa-list-group>
                <proa-list-group-item
                  class="settings-item"
                  @click.native="onClickSettingsItem('indexManagementOrganization')"
                >
                  {{ $t('pages.management.basicInformation.organizationInformation') }}
                </proa-list-group-item>
                <proa-list-group-item
                  class="settings-item"
                  @click.native="onClickSettingsItem('indexManagementLicensePlan')"
                >
                  {{ $t('pages.management.basicInformation.licensePlan') }}
                </proa-list-group-item>
                <proa-list-group-item
                  v-if="currentLicensedPlan.isBillingExist"
                  class="settings-item"
                  @click.native="onClickSettingsItem('indexManagementBillingHistories')"
                >
                  {{ $t('pages.management.basicInformation.billingHistories') }}
                </proa-list-group-item>
                <proa-list-group-item
                  :class="['settings-item', { 'disabled': currentLicensedPlan.planType === 'admin' || isMaintenaceMode || invalidPaymentSystem }]"
                  @click.native="onClickSettingsItem('editManagementLicensePlan')"
                >
                  <div>
                    <div>{{ $t('pages.management.basicInformation.changeLicensePlan') }}</div>
                    <div
                      v-if="currentLicensedPlan.planType === 'admin'"
                      class="text-error"
                    >
                      {{ $t('pages.management.cannotBeChangedFromAdminPlan') }}
                    </div>
                    <div
                      v-else-if="isMaintenaceMode"
                      class="text-error"
                    >
                      {{ $t('pages.management.cannotBeChangedDueToMaintenance') }}
                    </div>
                    <div
                      v-else-if="invalidPaymentSystem"
                      class="text-error"
                    >
                      {{ $t('pages.management.cannotBeChangedDueToPaymentSystem') }}
                    </div>
                  </div>
                </proa-list-group-item>
                <proa-list-group-item
                  v-if="currentLicensedPlan.contractType !== 'free'"
                  :class="['settings-item', { 'disabled': isMaintenaceMode }]"
                  @click.native="onClickSettingsItem('indexManagementPaymentMethod')"
                >
                  <div>
                    <div>{{ $t('pages.management.basicInformation.paymentMethodRegistration') }}</div>
                    <div
                      v-if="isMaintenaceMode"
                      class="text-error"
                    >
                      {{ $t('pages.management.cannotBeChangedDueToMaintenance') }}
                    </div>
                  </div>
                </proa-list-group-item>
              </proa-list-group>
            </proa-card>
          </b-col>
          <b-col cols="12" class="mt-4 pt-3">
            <proa-heading sub class="mb-3 pb-1">{{ $t('pages.management.sharewindSettings.heading') }}</proa-heading>
            <proa-card>
              <proa-list-group>
                <proa-list-group-item
                  class="settings-item"
                  @click.native="onClickInviteMember"
                >
                  {{ $t('pages.management.sharewindSettings.inviteNewMember') }}
                </proa-list-group-item>
                <proa-list-group-item
                  class="settings-item"
                  @click.native="onClickSettingsItem('indexManagementMembers')"
                >
                  {{ $t('pages.management.sharewindSettings.memberManagement') }}
                </proa-list-group-item>
                <proa-list-group-item
                  class="settings-item"
                  @click.native="onClickSettingsItem('indexManagementMeetingRooms')"
                >
                  {{ $t('pages.management.sharewindSettings.meetingRoomManagement') }}
                </proa-list-group-item>
              </proa-list-group>
            </proa-card>
          </b-col>
      </b-row>
    </b-container>
    <new-invite-user-modal
      :modal="newInviteUserModal"
      @close="newInviteUserModal = false"
      @invited="onClickSettingsItem('indexManagementMembers')"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import NewInviteUserModal from '@/components/organisms/NewInviteUserModal'
import PaymentSystem from '@/store/models/admin/PaymentSystem'

export default {
  name: 'IndexManagement',
  components: {
    NewInviteUserModal
  },
  computed: {
    invalidPaymentSystem: function() {
      return this.paymentSystem && !['active', 'usePay'].includes(this.paymentSystem.status)
    },
    paymentSystem: function() {
      return PaymentSystem.query().first()
    },
    ...mapGetters({
      signedInUser: 'auth/signedInUser',
      currentLicensedPlan: 'auth/currentLicensedPlan',
      currentOrganization: 'auth/currentOrganization'
    })
  },
  data(){
    return {
      newInviteUserModal: false,
      isMaintenaceMode: false
    }
  },
  methods: {
    onClickSettingsItem: function(to) {
      this.$router.push({ name: to })
    },
    onClickInviteMember: function() {
      this.newInviteUserModal = true
    },
    ...mapActions({
      apiGetPaymentSystems: 'entities/paymentSystems/index',
      apiGetSystemManage: 'systemManage/show'
    })
  },
  async created() {
    this.isMaintenaceMode = await this.apiGetSystemManage()
    this.apiGetPaymentSystems()
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";

.settings-item {
  cursor: pointer;

  &:hover {
    background-color: $light-gray-color;
  }

  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }
}
</style>
